import React from 'react';
const starsUrl = 'https://cdn.magicpatterns.com/uploads/exzAazkUkgurSCmLr3D6m9/Stars.svg';

// Solid Carli sparkle mark. Masked so it inherits a solid fill instead of an outline.
export function CarliStars({
  className = 'h-3.5 w-3.5',
  color = '#BB5E40'
}: {
  className?: string;
  color?: string;
}) {
  return <span aria-hidden="true" className={`inline-block shrink-0 ${className}`} style={{
    backgroundColor: color,
    WebkitMaskImage: `url(${starsUrl})`,
    maskImage: `url(${starsUrl})`,
    WebkitMaskRepeat: 'no-repeat',
    maskRepeat: 'no-repeat',
    WebkitMaskPosition: 'center',
    maskPosition: 'center',
    WebkitMaskSize: 'contain',
    maskSize: 'contain'
  }} data-id="element-309" data-mp="1uu89fjyl1zx2" />;
}